// @flow
// Manages state for all actions related to the MapToolBar
import { ids, mapToolbarReducer, mapToolbarInitialState } from 'catena/er2_ui'
import type { MapToolbarItemType, MapToolbarType, MapToolbarActionType } from 'catena/er2_ui'
import * as mapActionTypes from 'catena/er2_map_userlayers/js/constants/action_types'

// Override the behavior of the geo bar, or disable it here
const initialState = Object.assign({}, mapToolbarInitialState, {
    items: [{
        active: false,
        icon: { default: 'ms ms-layer' },
        id: ids.SELECT_BASE_LAYERS,
        name: 'Map Base Layer',
    }, {
        active: false,
        icon: { default: 'ms ms-layers' },
        id: ids.SELECT_USER_LAYERS,
        name: 'Map User Layers',
    }, {
        active: false,
        icon: { default: 'ms ms-table' },
        id: ids.SELECT_USER_TABLES,
        name: 'User Tables',
    }, {
        active: false,
        icon: { default: 'fa fa-cloud-download' },
        id: ids.SELECT_SERVICES,
        name: 'CSIP Services',
    }, {
        active: false,
        icon: { default: 'fa fa-calendar' },
        id: ids.SELECT_TIMESERIES,
        name: 'Timeseries',
    }],
    panel: {
        visible: false,
    },
})

export default function mapToolbarChild(state: MapToolbarType = initialState, action: MapToolbarActionType) {
    let newState = state
    // Listen for getAttributeTable, in which case we set the maptoolbar to be closed
    if (action.type === mapActionTypes.ATTRIBUTE_TABLE_SHOW) {
        newState = {
            ...state,
            items: state.items.map(i => ({ ...i, active: false })),
            panel: { ...state.panel, visible: false },
        }
    }

    return mapToolbarReducer(newState, action)
}
